import {ChooseSolutionComponent} from './ChooseSolutionComponent';

export default ChooseSolutionComponent;
